export const OnBoardingRepository = Symbol.for('OnBoardingRepository');
